export const FETCH_SURETY_AGENT_MANUALS_NAVIGATION_STARTED = "FETCH_SURETY_AGENT_MANUALS_NAVIGATION_STARTED";
export const FETCH_SURETY_AGENT_MANUALS_NAVIGATION_SUCCEEDED = "FETCH_SURETY_AGENT_MANUALS_NAVIGATION_SUCCEEDED";
export const FETCH_SURETY_AGENT_MANUALS_NAVIGATION_FAILED = "FETCH_SURETY_AGENT_MANUALS_NAVIGATION_FAILED";

export const FETCH_SURETY_AGENT_MANUALS_CONTENT_STARTED = "FETCH_SURETY_AGENT_MANUALS_CONTENT_STARTED";
export const FETCH_SURETY_AGENT_MANUALS_CONTENT_SUCCEEDED = "FETCH_SURETY_AGENT_MANUALS_CONTENT_SUCCEEDED";
export const FETCH_SURETY_AGENT_MANUALS_CONTENT_FAILED = "FETCH_SURETY_AGENT_MANUALS_CONTENT_FAILED";
